import React from "react";
import classNames from "classnames";
import { FilterValues } from "./FilterValuesCollection";

interface ProductListInStockFilterProperties {
    readonly isActive: boolean;
    readonly filter: FilterValues;

    readonly onFilterChange: (filter: FilterValues) => void;
    readonly onActivateTab: () => void;
}

export default function ProductListInStockFilter({
    isActive,
    filter,
    onFilterChange,
    onActivateTab,

}: ProductListInStockFilterProperties): React.JSX.Element {
    const handleFilterToggle = (stockId: number): void => {
        let currentInStock: number = filter.InStock ?? 0;

        // eslint-disable-next-line no-bitwise
        if (currentInStock & stockId) {
            // eslint-disable-next-line no-bitwise
            currentInStock &= ~stockId;
        } else {
            // eslint-disable-next-line no-bitwise
            currentInStock |= stockId;
        }

        onFilterChange(Object.assign({}, filter, { InStock: currentInStock === 0 ? undefined : currentInStock }));
    };

    return (
        <div className="filter-widget">
            <h2 className={isActive ? "active" : undefined} onClick={onActivateTab}>Skladová dostupnost<i className="fa-solid fa-caret-down"></i></h2>

            <div className={classNames("widget-content", { hidden: !isActive })}>
                <div className="filter-container green">
                    <label htmlFor="skladem">Pouze skladem
                        <input
                            type="checkbox"
                            id="skladem"
                            value="1"
                            // eslint-disable-next-line no-bitwise
                            checked={filter.InStock !== undefined && (filter.InStock & 1) === 1}
                            onChange={() => handleFilterToggle(1)} />
                        <span className="checkmark"></span>
                    </label>
                </div>
                <div className="filter-container">
                    <label htmlFor="skladem-partner">Skladem u partnera
                        <input
                            type="checkbox"
                            id="skladem-partner"
                            value="2"
                            // eslint-disable-next-line no-bitwise
                            checked={filter.InStock !== undefined && (filter.InStock & 2) === 2}
                            onChange={() => handleFilterToggle(2)} />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </div>
        </div>
    );
}
